import React, { useState } from "react";
import "./Toggle.css";

const Toggle = ({ label, isOn, onChange, disabled }) => {
  const handleToggle = () => {
    if (!disabled && onChange) onChange(!isOn);
  };

  return (
    <div className="toggle-container">
      {label && <span className="toggle-label">{label}</span>}
      <div
        className={`toggle-switch ${isOn ? "on" : "off"} ${
          disabled ? "disabled" : ""
        }`}
        onClick={!disabled ? handleToggle : undefined}
      >
        <div className="toggle-thumb" />
      </div>
    </div>
  );
};

export default Toggle;

// const Toggle = ({ label, isOn, onChange, disabled }) => {
//   const handleToggle = () => {
//     if (!disabled && onChange) {
//       onChange(!isOn);
//     }
//   };

//   return (
//     <div className="toggle-container">
//       {label && <span className="toggle-label">{label}</span>}
//       <div
//         className={`toggle-switch ${isOn ? "on" : "off"} ${
//           disabled ? "disabled" : ""
//         }`}
//         onClick={!disabled ? handleToggle : undefined}
//       >
//         <div className="toggle-thumb" />
//       </div>
//     </div>
//   );
// };
